






































































































import Worklist from '@/components/Navigation/WorklistView.vue'
import userModule from '@/store/modules/UserModule'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import UserProfile from '../Users/UserProfile.vue'

@Component({
  components: {
    Worklist,
    UserProfile
  }
})
export default class TopNavBar extends Vue {
  @Prop() public pageActive!: string
  public isScrolled = false
  public showAlertDialog = false

  public get userIsReportingUser () {
    return userModule.userIsReportingUser
  }

  public get canSeeAdminMenu () {
    return userModule.canManageUser || userModule.canManageCustomer
  }

  public get canManageUser () {
    return userModule.canManageUser
  }

  public get canManageCustomer () {
    return userModule.canManageCustomer
  }

  public get canManageSnpMapping () {
    return userModule.canManageSnpMapping
  }

  public get isAdmin () {
    return userModule.userIsAdmin
  }

  public onScroll (): void {
    this.isScrolled = window.scrollY > 20
  }
}
